export default __webpack_public_path__ + "static/media/floral.74f16b8f.png";